var site = site || {};

// hide panels with CSS
// mark default open panels and title with .init--open
// var params = {
//   title: $title, // title div, js-accordion__title
//   panel: $panel, // panel div, js-accordion__panel
//   panelToShow: 0 // initial panel to show
// }

site.BasicAccordion = function(params) {
  var $titles = $(params.titles);
  var $panels = $(params.panels);
  $('.init--open').addClass('active');
  if ( !_.isUndefined(params.panelToShow) ) {
    $titles.eq(params.panelToShow).addClass('active');
    $panels.eq(params.panelToShow).addClass('active').slideDown(function() {
      $(document).trigger('BasicAccordion.init');
    });
  }

  $titles.on('click', function(event) {
    event.preventDefault();
    $this = $(this);
    $target = $this.next();

    if (!$target.hasClass('active')){
      $this.addClass('active');
      $target.addClass('active').slideDown(function() {
        $(document).trigger('BasicAccordion.opened');
      });
    } else {
      $this.removeClass('init--open active');
      $target.removeClass('active').slideUp(function(){
        $target.removeClass('init--open');
      });
    }

    return false;
  });
};
